export const UnfoldMoreIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8023_48967)">
      <path d="M8.00042 3.88667L9.64042 5.52667C9.90042 5.78667 10.3204 5.78667 10.5804 5.52667C10.8404 5.26667 10.8404 4.84667 10.5804 4.58667L8.46708 2.46667C8.20708 2.20667 7.78708 2.20667 7.52708 2.46667L5.41375 4.58667C5.15375 4.84667 5.15375 5.26667 5.41375 5.52667C5.67375 5.78667 6.09375 5.78667 6.35375 5.52667L8.00042 3.88667ZM8.00042 12.1133L6.36042 10.4733C6.10042 10.2133 5.68042 10.2133 5.42042 10.4733C5.16042 10.7333 5.16042 11.1533 5.42042 11.4133L7.53375 13.5333C7.79375 13.7933 8.21375 13.7933 8.47375 13.5333L10.5871 11.42C10.8471 11.16 10.8471 10.74 10.5871 10.48C10.3271 10.22 9.90708 10.22 9.64708 10.48L8.00042 12.1133Z" />
    </g>
    <defs>
      <clipPath id="clip0_8023_48967">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
